<template>
  <div class="o-flex-cols__row is-loading">
    <div class="o-flex-cols__row--1col overflow-x-auto">
      <div class="c-data-box" style="min-width: 800px;">
        <div class="c-data-content__header">
          <div class="c-data-content__experiment--title">
              <h4 class="c-data-content__title">{{ $t('experiments.table.title')}}</h4>
          </div>
          <div class="c-data-content__experiment--state">
              <h4 class="c-data-content__title">{{ $t('experiments.table.state')}}</h4>
          </div>
          <div class="c-data-content__experiment--ctr">
              <h4 class="c-data-content__title">{{ $t('experiments.table.ctr')}}</h4>
          </div>
          <div class="c-data-content__experiment--data">
              <h4 class="c-data-content__title">{{ $t('experiments.table.data')}}</h4>
          </div>
          <div class="c-data-content__experiment--editor">
              <h4 class="c-data-content__title">{{ $t('experiments.table.editor')}}</h4>
          </div>
          <div class="c-data-content__experiment--client">
              <h4 class="c-data-content__title">{{ $t('experiments.table.client')}}</h4>
          </div>
          <div class="c-data-content__experiment--details"></div>
        </div>

        <experiment-row v-for="experiment in experiments" :key="experiment.id" :experiment="experiment" />

        <div class="c-data-content__footer">
            <div class="c-data-content__experiment--client">
                <h4 class="c-data-content__title">{{ $t('experiments.totals', { total: pagination.count } )}}</h4>
            </div>
            <div class="c-data-content__experiment--title">
              <pagination
                v-if="pagination.count > 10"
                :items="Array(pagination.count)"
                @changePage="onPageChanged"
              />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExperimentRow from './ExperimentRow.vue'
import Pagination from '../common/Pagination.vue'

export default {
  components: {
    ExperimentRow,
    Pagination,
  },
  props: {
    experiments: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    onPageChanged: {
      type: Function,
      required: true,
    },
  },
}
</script>
